<template>
    <div class="inner-wrap" >
        <div class="left" :style="{'max-height': height}">
            <h1>Upload Your Design Draft</h1>
            <div class="form-group w50">
                <div class="form-control">
                    <select :value="form_data.parent_product_category_id" @change="change1($event, 'parent_product_category_id')">
                        <option value="0" v-if="form_data.parent_product_category_id===0">Please Select</option>
                        <option v-for="(v, k) in product_category_list" :key="`dpc1` + k" :value="v.product_category_id">
                            {{ v.category_name_en }}
                        </option>
                    </select>
                </div>
            </div>
            <div v-show="sub_product_category_list.length > 0" class="form-group w50">
                <div class="form-control">
                    <select :value="form_data.child_product_category_id" @change="change1($event, 'child_product_category_id')">
                        <option value="0">Please Select</option>
                        <option v-for="(v, k) in sub_product_category_list" :key="`dpc2` + k" :value="v.product_category_id">
                            {{ v.category_name_en }}
                        </option>
                    </select>
                </div>
            </div>

            <div class="main-image">
                <template v-if="main_file.raw">
                    <template v-if="util.test_image(main_file.raw)">
                        <img :src="main_file.raw" v-viewer alt="" style="width: 100%; height: 100%;object-fit:cover;"/>
                    </template>
                    <template v-else>
                        <img :src="util.get_image_icon(main_file.raw)" class="icon-doc" />
                        <a :href="main_file.raw" target="_blank" style="width: 100%;text-align: center;">{{main_file.raw_name}}</a>
                    </template>
                </template>
                <template v-else>
                    <Upload
                            :action="upload_url"
                            :data="{ dir: 'template' }"
                            :before-upload="(file)=>onBeforeUpload(file, 'image_list')"
                            :show-upload-list="false"
                            type="drag"
                            multiple
                    >
                        <div class="main-image">
                            <img alt="" class="icon-upload" src="@/assets/images/icon-add-3.png" style="object-fit:cover;"/>
                            <p>Support Upload Image or File, jpeg,jpg,psd,cdr and so on</p>
                        </div>
                    </Upload>
                </template>
            </div>

            <div class="img-list">
                <div
                        v-for="(v, k) in form_data.image_list"
                        :key="`i` + k"
                        class="img-item" draggable
                        @dragstart="handleDragStart($event, k)"
                        @dragover.prevent
                        @drop="handleDrop($event, k)" @click.prevent.stop="set_image(v)"
                >
                    <template v-if="typeof(v) === 'string'">
                        <img :src="v" alt="" style="object-fit:cover;" />
                    </template>
                    <template v-else>
                        <img v-if="util.test_image(v.raw)" :src="v.raw" alt="" style="object-fit:cover;" />
                        <img v-else :src="util.get_image_icon(v.raw)" alt="" style="object-fit:cover;" />
                    </template>
                    <img alt="" class="icon-close" src="@/assets/images/icon-close@2x.png" @click.prevent.stop="del_img(k)"/>
                </div>
                <Upload
                        :action="upload_url"
                        :data="{ dir: 'template' }"
                        :before-upload="(file)=>onBeforeUpload(file, 'image_list')"
                        :show-upload-list="false"
                        multiple
                >
                    <div class="img-item">
                        <span>+</span>
                        <span>Add</span>
                    </div>
                </Upload>
            </div>


            <div class="form-group">
                <div class="form-label">Style Description</div>
                <div class="form-control">
                    <textarea id="textarea" :value="form_data.description" @input="input1($event, 'description')" placeholder="Please Enter Your Style Description"></textarea>
                </div>
            </div>
        </div>

        <div class="right">
            <Lesson v-if="is_lesson_show"></Lesson>
        </div>
    </div>
</template>

<script>
    import util from '@/utils/util'
    import {mapState} from 'vuex'
    import Lesson from "./Lesson.vue";
    import { uploadFileToOSS } from "@/utils/oss";

    export default {
        name: "Manuscript",
        data() {
            return {
                util: util,
                upload_url: process.uniEnv.BASE_API + "/util/upload-image",
                sub_product_category_list: [],
                is_popup_show: false,
                main_file: {
                    raw: "",
                    raw_name: ""
                }
            }
        },
        components: {
            Lesson
        },
        watch: {
            "form_data.parent_product_category_id": {
                handler(newVal, oldVal) {
                    console.log('base', newVal, oldVal)
                    if (newVal > 0) {
                        let obj = this.product_category_list.find((v) => v.product_category_id === newVal);
                        this.sub_product_category_list = obj ? obj.children : [];
                        if (oldVal > 0) {
                            this.$store.commit("design/update_common", {key: 'child_product_category_id', value: 0})
                        }
                    }
                },
                immediate: true, // 立即执行一次handler以初始化数据
            },
            "form_data.image": function(newVal, oldVal) {
                if(newVal) {
                    this.main_file = {
                        raw: newVal,
                        raw_name: ''
                    }
                } else if(this.form_data.image_list.length > 0) {
                    this.main_file = this.image_list[0]
                }
            },
            height(news,olds){
                console.log('news',news);
            }
        },
        computed: {
            ...mapState({
                form_data: (state) => state.design.form_data,
                height: (state) => state.design.height,
                is_lesson_show: (state) => state.design.is_lesson_show,
                product_category_list: (state) => state.design.product_category_list,
            }),
        },
        mounted(){
            //防止在点开弹窗以后直接刷新页面导致再次进入弹窗不关闭的问题
            this.$store.commit('design/hide_lesson_popup');
        },
        methods: {
            set_image(obj) {
                if(typeof obj === 'object') {
                    this.main_file = obj
                } else {
                    this.main_file = {
                        raw: obj,
                        raw_name: ''
                    }
                }
            },
            change1($event, field) {
                this.$store.commit('design/update_common', {key: field, value: parseInt($event.target.value)})
            },
            input1($event, field) {
                this.$store.commit('design/update_common', {key: field, value: $event.target.value})
            },
            handleDragStart(event, draggedIndex) {
                event.dataTransfer.setData("draggedIndex", draggedIndex);
            },
            handleDrop(event, targetIndex) {
                event.preventDefault();
                const draggedIndex = event.dataTransfer.getData("draggedIndex");
                if (draggedIndex === targetIndex) return;
                let image_list = this.form_data.image_list
                const draggedItem = image_list.splice(draggedIndex, 1)[0];
                image_list.splice(targetIndex, 0, draggedItem);
                this.$store.commit('design/update_common', {key: 'image_list', value: image_list})
            },
            del_img(k) {
                this.$store.commit('design/arr_remove_one', {key: 'image_list', index: k})
                let len = this.form_data.image_list.length;
                if (len === 0) {
                    this.main_file = {raw: '', raw_name: ''}
                } else {
                    if(typeof this.form_data.image_list[0] === 'object') {
                        this.main_file = this.form_data.image_list[0]
                    } else {
                        this.main_file = {
                            raw: this.form_data.image_list[0],
                            raw_name: ''
                        }
                    }
                }
            },
            onBeforeUpload(file, field) {
                if(this.form_data.image_list.length >= 15) {
                    this.$layer.msg(`You can add up to 15 design images`)
                    return
                }
                uploadFileToOSS(file, 'template').then(url => {
                    if (field === "image_list") {
                        let object = {}
                        object.raw = url;
                        object.raw_name = file.name;
                        this.$store.commit('design/arr_push_one', {key: 'image_list', value: object})
                        if(this.form_data.image_list.length === 1) {
                            this.main_file = object
                        }
                    }
                })
                return false;
            },
        }
    }
</script>

<style scoped lang="scss">
    .inner-wrap {
        display: flex;
        flex-wrap: nowrap;
        // flex-direction: column;
        width:100%;
        height:100%;
        .left {
            padding: 0 30px 100px 30px;
            width: 490px;
            height:100%;
            // flex:1;
            background: white;
            overflow: auto;
            display: flex;
            flex-wrap: wrap;
            align-content: flex-start;
            h1 {
                width: 100%;
                height: 20px;
                line-height: 20px;
                font-size: 18px;
                color: #000000;
                border-left: 2px solid black;
                padding-left: 10px;
                margin: 15px 0;
            }
            .form-group {
                // width: 420px;
                width:100%;
                margin-bottom: 25px;

                &.w50 {
                    width: 202px;
                    margin-right: 5px;
                }

                .form-label {
                    font-size: 14px;
                    color: #1a1a1a;
                    margin: 10px 0;
                    padding-left: 10px;
                    border-left: 2px solid black;
                    span {
                        font-size: 14px;
                        color: #fa3d5a;
                        font-weight: normal;
                    }
                }

                .form-control {
                    position: relative;
                    .input,
                    select {
                        width: 100%;
                        height: 43px;
                        line-height: 43px;
                        padding: 0 15px;
                        border: 1px solid #e2e5e9;
                        font-size: 14px;
                        border-radius: 5px;
                    }
                    textarea {
                        // width: 420px;
                        width:100%;
                        height: 180px;
                        padding: 15px;
                        background: #F8F9FC;
                        border: 1px solid #D1D1D1;
                        border-radius: 5px;
                    }
                }
            }
            .main-image {
                display: flex;
                flex-wrap: wrap;
                justify-content: center;
                align-items: center;
                align-content: center;
                background: #fafafa;
                // width: 411px;
                width:100%;
                height: 411px;
                border-radius: 5px;
                border: 1px dashed #B3B3B3;
                &:hover{
                    border:1px dashed skyblue;
                }
                ::v-deep .ivu-upload{
                    width:100%;
                    border:none;
                }
                .icon-upload {
                    width: 52px;
                    height: 60px;
                }

                .icon-doc {
                    width: 50px;
                    height: 50px;
                }
                p {
                    width: 100%;
                    color: #4d4f52;
                    font-size: 14px;
                    margin-top: 26px;
                    text-align: center;
                }
            }

            .img-list {
                margin: 20px 0 30px;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                flex-wrap: wrap;
                .img-item {
                    position: relative;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    align-content: center;
                    flex-wrap: wrap;
                    width: 60px;
                    height: 60px;
                    margin: 4px;
                    border: 1px solid #e2e5e9;
                    border-radius: 5px;
                    color: #9e9e9e;
                    cursor: pointer;

                    span {
                        width: 60px;
                        height: 15px;
                        text-align: center;
                    }

                    .icon-close {
                        position: absolute;
                        width: 15px;
                        height: 15px;
                        top: 0;
                        right: 0;
                    }
                }
            }
        }
        .right {
            display:flex;
            align-items:center;
            justify-content:center;
            flex:1;
        }
    }
    @media (min-width:1280px) and (max-width:1679px){
        .inner-wrap .left{
            width:440px;
        }
    }

    @media (max-width:1279px){
        .inner-wrap .left{
            width:350px;
        }
    }
</style>
